var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"author-answer",domProps:{"innerHTML":_vm._s(_vm.text.replace(/https:\/\/newapi.mysimulator.ru/g, _vm.$url))}})}
var staticRenderFns = []

export { render, staticRenderFns }